import { CheckoutFormField } from "./CheckoutFormField";
import { CheckoutFormFieldWrapper } from "./CheckoutFormFieldWrapper";

export const CheckoutFormNameField = () => (
  <CheckoutFormFieldWrapper name="name">
    <CheckoutFormField type="text" name="name" options={{ required: true }} />
  </CheckoutFormFieldWrapper>
);
